import React, { useRef } from "react";

const Qualification = () => {
  const tabs = useRef();
  const tabContents = useRef();
  //const tabs =  document.querySelectorAll('[data-target]');
  //const tabContents =  document.querySelectorAll('[data-content]');
  const toggleQulify = (event) => {
    debugger;
    const target = event.currentTarget;
    const target1 = event.currentTarget.dataset.target;

    tabContents.current.childNodes.forEach((tabContent) => {
      tabContent.classList.remove("qualification__active");

      if (tabContent.id === target1.substring(1)) {
        tabContent.classList.add("qualification__active");
      }
    });

    tabs.current.childNodes.forEach((tab) => {
      tab.classList.remove("qualification__active");
    });
    target.classList.add("qualification__active");
  };

  return (
    <>
      <section className="qualification section">
        <h2 className="section__title">Qualification</h2>
        <span className="section__subtitle">My personal journey</span>

        <div className="qualification__container container">
          <div className="qualification__tabs" ref={tabs}>
            <div
              className="qualification__button button--flex qualification__active"
              onClick={toggleQulify}
              data-target="#education"
            >
              <i className="uil uil-graduation-cap qualification__icon"></i>
              Education
            </div>
            <div
              className="qualification__button button--flex"
              onClick={toggleQulify}
              data-target="#work"
            >
              <i className="uil uil-briefcase-alt qualification__icon"></i>
              Work
            </div>
          </div>

          <div className="qualification__sections" ref={tabContents}>
            <div
              className="qualification__content  qualification__active"
              data-content
              id="education"
            >
              <div className="qualification__data">
              <div>
                  <h3 className="qualification__title">12TH (HSC)</h3>
                  <span className="qualification__subtitle">
                    S.F. High school, Chhota udepur, Gujarat
                  </span>
                  <div className="qualification__calendar">
                    <i className="uil uil-calendar-alt"></i>
                    2014
                  </div>
                </div>
                <div>
                  <span className="qualification__rounder"></span>
                  <span className="qualification__line"></span>
                </div>
              </div>

              <div className="qualification__data">
                <div></div>

                <div>
                  <span className="qualification__rounder"></span>
                  <span className="qualification__line"></span>
                </div>
                <div>
                  <h3 className="qualification__title">
                    BACHELOR OF ENGINEERING (IT)
                  </h3>
                  <span className="qualification__subtitle">
                    L.D collage of Engineering, Ahmedabad, Gujarat
                  </span>
                  <div className="qualification__calendar">
                    <i className="uil uil-calendar-alt"></i>
                    2018
                  </div>
                </div>

                
              </div>

              <div className="qualification__data">
              <div>
                  <h3 className="qualification__title">
                    MASTER OF ENGINEERING (CE)
                  </h3>
                  <span className="qualification__subtitle">
                    Government Engineering College, Modasa, Gujarat.
                  </span>
                  <div className="qualification__calendar">
                    <i className="uil uil-calendar-alt"></i>
                    2020
                  </div>
                </div>
                <div>
                  <span className="qualification__rounder"></span>
                  {/* <span className="qualification__line"></span> */}
                </div>
              </div>

          
            </div>

            <div className="qualification__content" data-content id="work">
              <div className="qualification__data">
                <div></div>
                <div>
                  <span className="qualification__rounder"></span>
                  {/* <span className="qualification__line"></span> */}
                </div>
                <div>
                  <h3 className="qualification__title">Software Developer</h3>
                  <span className="qualification__subtitle">Compucare india Pvt. Ltd. - Vadodara</span>
                  <div className="qualification__calendar">
                    <i className="uil uil-calendar-alt"></i>
                    2021 - Present
                  </div>
                </div>
              </div>

              {/* <div className="qualification__data">
                                <div></div>

                                <div>
                                    <span className="qualification__rounder"></span>
                                    <span className="qualification__line"></span>
                                </div>

                                <div>
                                    <h3 className="qualification__title">Computer Engineer</h3>
                                    <span className="qualification__subtitle">GTU University</span>
                                    <div className="qualification__calendar">
                                        <i className="uil uil-calendar-alt"></i>
                                        2014 - 2018
                                    </div>
                                </div>

                                
                            </div> */}

              {/* <div className="qualification__data">
                                <div>
                                    <h3 className="qualification__title">Computer Engineer</h3>
                                    <span className="qualification__subtitle">GTU University</span>
                                    <div className="qualification__calendar">
                                        <i className="uil uil-calendar-alt"></i>
                                        2014 - 2018
                                    </div>
                                </div>

                                <div>
                                    <span className="qualification__rounder"></span>
                                     <span className="qualification__line"></span> 
                                </div>
                            </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Qualification;
